"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMarket = isMarket;
function isMarket(value) {
    return value === 'S' || value === 'G';
}
